module.exports = __webpack_public_path__ + "img/LKN.a2a4fcfd.svg";